import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { RouterManagerService } from './router-manager.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})

export class PermissionGuardService implements CanActivate {


  constructor(private router: Router, private routerManager: RouterManagerService) {

  }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    this.routerManager.restrictThroughPermissions(route.data.permissions, route.data.operation);

    return this.routerManager.arePermissionsAuthorized();

  }


}
